export default __webpack_public_path__ + "static/media/change_plan.6bb21a0d.svg";